var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0848 3.67497C26.2335 -1.22713 33.3984 -1.22712 36.5471 3.67498L40.9961 10.6018C42.0795 12.2884 43.7566 13.5069 45.6955 14.016L53.6581 16.1069C59.2932 17.5866 61.5073 24.4009 57.8181 28.9102L52.6052 35.282C51.3359 36.8336 50.6953 38.8051 50.8102 40.8064L51.2823 49.0254C51.6164 54.842 45.8198 59.0535 40.3911 56.9383L32.7203 53.9496C30.8524 53.2218 28.7794 53.2218 26.9116 53.9496L19.2407 56.9383C13.812 59.0535 8.01547 54.842 8.34955 49.0254L8.82162 40.8064C8.93657 38.8051 8.29597 36.8336 7.02663 35.282L1.81372 28.9102C-1.87548 24.4008 0.338629 17.5866 5.97379 16.1069L13.9364 14.016C15.8753 13.5069 17.5524 12.2884 18.6357 10.6018L23.0848 3.67497Z",
    fill: "#C5D633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/Star 1.7056b3725f89e9a4ba7d919da7a75d6e.svg";
export { ForwardRef as ReactComponent };